import _get from 'lodash/get';

// constants
import { APP_PAGES } from '@tajawal/web-core-sdk-v2/lib/constants';
import { GLOBAL } from '@/constants/common.constants';
import _includes from 'lodash/includes';

export const getPageName = (pathName = ''): string => {
  if (pathName.includes('flights-home')) {
    return APP_PAGES.FLIGHTS_HOME;
  }
  if (pathName.includes('flights')) {
    return APP_PAGES.FLIGHTS_RESULTS;
  }
  if (pathName.includes('traveller')) {
    return APP_PAGES.FLIGHTS_PAX;
  }
  if (pathName.includes('extras')) {
    return APP_PAGES.FLIGHTS_EXTRAS;
  }
};

export function getPosInformation(posConfig, countryCode, isCOM, isSA) {
  let defaultCountryCode = '';
  if (isCOM && !isSA) {
    defaultCountryCode = GLOBAL;
  } else {
    defaultCountryCode = countryCode;
  }
  const defaultPos = _get(posConfig, defaultCountryCode, false);

  return defaultPos;
}

export function getABTestingAttr({ pathName, asPath, userID, config }) {
  const { posConfig, countryCode, isCOM, isSA } = config || {};
  return {
    page: getPageName(pathName),
    platform: _includes(asPath, '/mweb/') ? 'mweb' : 'dweb',
    isLoggedIn: !!userID,
    pos: getPosInformation(posConfig, countryCode, isCOM, isSA)?.code,
  };
}
